import { Component, OnInit, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Resolve } from '@angular/router';
import { PaySystem, PaySystemService } from '../pay-system.service';
import { Delivery, DeliveryService } from '../delivery.service';
import { getTitle, getDescription } from '../../lib/helpers';
import { CartItem, CartService } from '../cart.service';
import { BreadCrumbsService } from '../../breadcrumbs.service';
import { RestComponent } from '../../lib/RestComponent';
import { ConsultService } from '../../consult.service';

@Component({
  selector: 'cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.less']
})
export class CartPageComponent extends RestComponent implements OnInit {
  paySystems: PaySystem[] = [];
  deliveries: Delivery[] = [];

  constructor(
    private route: ActivatedRoute,
    public cartService: CartService,
    private titleService: Title,
    private metaService: Meta,
    private consult: ConsultService,
    private breadCrumbsService: BreadCrumbsService,
  ) {
    super();
    this.titleService.setTitle(getTitle('Корзина'));
    this.metaService.updateTag({name: 'description', content: getDescription('Корзина')});

    this.breadCrumbsService.create([{
      name: 'Корзина',
      color: 'general-primary'
    }]);
  }

  public ngOnInit() {
    this.route.data.subscribe((data: {data: {paySystems: PaySystem[], deliveries: Delivery[]}}) => {
      this.paySystems = data.data.paySystems;
      this.deliveries = data.data.deliveries;
    });
  }

  get itemsPriceFromCount(): number {
    if (this.cartService.cart && this.cartService.cart.ITEMS.length > 0) {
      return this.cartService.cart.ITEMS.reduce((sum: number, current: CartItem) => {
        return (current.PRICE_ARR.QUANTITY_FROM ? 1 + sum : sum);
      }, 0);
    } else return 0;
  }

  get totalCurrency(): string {
    return (this.cartService.cart && this.cartService.cart.ITEMS.length > 0) ?
      this.cartService.cart.ITEMS[0].PROVIDER_DATA.CURRENCY :
      'RUB';
  }

  public async updateQuantity(item: CartItem, quantity: number) {
    this.loadingState = true;
    try {
      await this.cartService.update({ID: item.OFFER_ID, QUANTITY: quantity});
      this.loadingState = false;
    } catch (e) {
      this.loadingState = false;
    }
  }

  public async removeFromCart(id: number) {
    this.loadingState = true;
    try {
      const res = await this.cartService.delete(id);
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    } catch (e) {
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    }
  }
}

@Injectable()
export class CartPaySystemsResolver implements Resolve<{
  paySystems: PaySystem[],
  deliveries: Delivery[]
}> {
  constructor(
    private paySystemService: PaySystemService,
    private deliveryService: DeliveryService,
    private consult: ConsultService,
  ) {}

  public async resolve(): Promise<{
    paySystems: PaySystem[],
    deliveries: Delivery[]
  }> {
    const res: {
      paySystems: PaySystem[],
      deliveries: Delivery[]
    } = {paySystems: null, deliveries: null};

    try {
      res.paySystems = await this.paySystemService.get({
        filter: {ACTIVE: 'Y'}
      });

      res.deliveries = await this.deliveryService.get({
        filter: {ACTIVE: 'Y', PARENT_ID: null}
      });

      return res;
    } catch (e) {
      this.consult.notification({
        name: 'Ошибка при входе в корзину. Попробуйте ещё раз',
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      return null;
    }
  }
}
